// import data from "../../shared/sharedData";
export default {
  name: "Place of Employment Information",
  prefix: "E.c",
  pageInfo: {
    text: "<strong>Important Note</strong>: It is important for the employer to define the area of intended employment with <u>as much geographic specificity as possible</u>.  This information is used for purposes of reviewing and verifying regulatory compliance with advertising, positive recruitment requirements, and prevailing wages when used in connection with a request for temporary labor certification. ",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          code: "E.c.1",
          machine_name: "primaryWorksiteAddr1",
          widget: "text",
          label: "Worksite Address 1",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Address 1 must contain at least 2 characters.",
            },
            "noNAs",
          ],
          maxLength: 60,
          tooltip:
            "Enter the business street address for the requestor’s point of contact.  The address must be a physical location.  Since the address conventions in the CNMI do not always follow the format normally used in the continental United States, see the Address Note for CNMI at the end of these general instructions.",
        },
        {
          code: "E.c.2",
          machine_name: "primaryWorksiteAddr2",
          widget: "text",
          label: "Address 2",
          maxLength: 60,
          tooltip: `Enter the specific CNMI Island.  If additional space is needed for the street address or entry of a P.O. Box, use this field.  If no additional space is needed, enter “N/A.”`,
        },
        {
          code: "E.c.3",
          machine_name: "primaryWorksiteCity",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
            "noNAs",
          ],
          maxLength: 60,
          tooltip: "Enter the city of the worksite location.",
        },
        {
          code: "E.c.4",
          machine_name: "primaryWorksiteState",
          widget: "select",
          label: "State",
          validate: ["required", "noNAs"],
          placeholder: ["NORTHERN MARIANA ISLANDS"],
          selection: ["NORTHERN MARIANA ISLANDS"],
          disabled: true,
          tooltip:
            "Enter the State, District, or Territory of the worksite location.",
        },
        {
          code: "E.c.5",
          machine_name: "primaryWorksitePostalCode",
          widget: "text",
          label: "Postal Code",
          validate: [
            "required",
            { postalCompare: ["96950", "96951", "96952"] },
            "noNAs",
          ],
          maxLength: 10,
          tooltip: "Enter the postal (zip) code of the worksite location.",
        },
        {
          isGroup: {
            code: "E.c.6",
            machine_name: "otherWorksiteLocation",
            label:
              "Will work be performed in multiple worksites or locations other than the address listed above?",
            required: true,
            tooltip: `If work will be performed in location(s) in addition to the address listed in questions 1-6 above, mark “Yes” and complete question 7-A.  If work will <u>not</u> be performed in location(s) other than the address listed in questions 1-6 above, mark “No.”`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["otherWorksites"],
              },
            ],
          },
        },
      ],
    },
  ],
};
